import React, { useState } from 'react'
import { Button, Card } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import '../../style/reflejos.css'
import reflejosImg from '../../assets/reflejos.png'

const Reflejos = () =>{
    const [modal,SetModal] = useState(false);
    const OpenCLoseModal = ()=>{
        SetModal(!modal);
        //GameLogic();
    }
    const GameLogic = () =>{
        var forma = document.getElementById('forma');
        var pReaccion = document.getElementById('ReactionTime');
        var rBtn = document.getElementById('reflejosBtn');
        if(forma !== null && pReaccion !== null){
        forma.hidden = false;
        rBtn.hidden = true;
        var start = new Date().getTime();

        const getRandomColor = () =>{

        var letters = '0123456789ABCDEF'.split('');
        let color = "#";
        for (var i = 0; i < 6; i++) {
            color += letters[Math.round(Math.random() * 15)];
        }
        return color;
        }

        const AparecerForma = () =>{

        var top = Math.random() * 200,
        left = Math.random() * 200,
        width = (Math.random() * 100 ) + 50,
        color = getRandomColor();

        forma.style.display = 'block';
        forma.style.top = top + "px";
        forma.style.left = left + "px";
        forma.style.width = width + "px";
        forma.style.height = width + "px";
        forma.style.backgroundColor = color;
        if (Math.random() > 0.5)

            forma.style.borderRadius = "50%";
        else
            forma.style.borderRadius = "0%";

        start = new Date().getTime();
        }

        const AparecerFormaConRetraso = () =>{

        setTimeout(AparecerForma,Math.random() * 2000);
        }


        AparecerFormaConRetraso();
        forma.onclick = function (){

        forma.style.display = 'none';
        var end = new Date().getTime();
        var diferencia = (end - start) / 1000;
        pReaccion.innerHTML = diferencia + " s";
        AparecerFormaConRetraso();
        };
    }

    }
    return (
        <>
            <Card className = "shadow">
                <div className  = "img-animation">
                    <Card.Img variant="top"  src = {reflejosImg}/>
                </div>
                <Card.Body>
                    <Card.Title>¡Comprueba tus Reflejos!</Card.Title>
                    <Card.Text>
                    Una figura aparece en la pantalla, tócala lo más rápido que puedas 
                    </Card.Text>
                    <Button onClick = {()=>OpenCLoseModal()} className = "btn custom-btn">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        Jugar
                    </Button>
                </Card.Body>
            </Card>
            <Modal 
                show = {modal}
                onHide = {()=>OpenCLoseModal()}>
                <Modal.Header closeButton>¡Comprueba tus reflejos!</Modal.Header>
                <Modal.Body>

                <div className="box">
                    <p >tiempo de reacción: <span id="ReactionTime"></span> </p>
                    <div hidden id="forma">

                    </div>
                    <button id = "reflejosBtn" className = "btn btn-primary" onClick = {()=>GameLogic()}> go </button>

                </div>
                </Modal.Body>
                    <Modal.Footer>
                        <button onClick = {()=>OpenCLoseModal()} className="btn btn-danger">
                            Cerrar
                        </button>
                    </Modal.Footer>
            </Modal>
        </>
    )
}
export default Reflejos